import React from 'react'

export default function ReportsComingSoon(props) {
    return <h4>
        The reports will be available at a later date.
    </h4>
}
